import { IBasicInfoPopupProps } from '../BasicInfoPopup/BasicInfoPopup.types';
import BasicInfoPopup from '../BasicInfoPopup/BasicInfoPopup';
import { Stack } from '../../core';
import ViaeroButton from '../../core/ViaeroButton/ViaeroButton';
import { useMaxItemPopupStyles } from './MaxItemPopup.styles';
import { MainContext } from '../../../contexts/MainContext/MainContext';
import { useContext } from 'react';

const MaxItemPopup = (props: IBasicInfoPopupProps) => {
    const { isMobile } = useContext(MainContext);
    const styles = useMaxItemPopupStyles();

    const handleChatClick = () => {
        window.location.href = '/contact';
    };

    const handleFindStoreClick = () => {
        window.location.href = '/find-a-store/';
    };

    return (
        <BasicInfoPopup {...props}>
            <Stack horizontal={!isMobile} spaced className={styles.buttonContainer}>
                <ViaeroButton
                    className={styles.button}
                    text={'Chat With Us'}
                    click={handleChatClick}
                />
                <ViaeroButton
                    className={styles.button}
                    text={'Find Nearest Store'}
                    click={handleFindStoreClick}
                />
            </Stack>
        </BasicInfoPopup>
    );
};

export default MaxItemPopup;
